module.exports = __webpack_public_path__ + "static/media/businesslunch-catering-1.e7ae288d.jpg";